import { Flex } from '@chakra-ui/react';
import { CurrencyInput } from 'src/chakra-components/Input/CurrencyInput';
import { OrderSource } from 'src/entities/Order';

export const ShippingCostField = ({
  requiresShippingCost,
  field,
  disabled,
  orderSource,
}) => {
  const salesControlSources = [
    OrderSource.VENDORS_PORTAL,
    OrderSource.SALES_APP,
  ];

  if (requiresShippingCost) {
    return (
      <>
        <CurrencyInput isDisabled={disabled} {...field} />
        <p className="text-secondary">
          Você pode editar esse campo até um dia antes do pagamento do repasse
        </p>
      </>
    );
  }

  if (salesControlSources.includes(orderSource)) {
    return (
      <Flex
        align="center"
        justify="center"
        padding="12px"
        borderRadius="md"
        border="1px solid"
        borderColor="inherit"
        w="100%"
        opacity="0.4"
        fontSize="lg"
      >
        <span>
          Não é possível editar, pois o valor de custo de envio está incluso no
          valor total do pedido.
        </span>
      </Flex>
    );
  }

  return (
    <div>
      <Flex
        align="center"
        justify="center"
        h="48px"
        borderRadius="md"
        border="1px solid"
        borderColor="inherit"
        w="100%"
        opacity="0.4"
        fontSize="lg"
      >
        <span data-testid="freeShippingCost">Envio Grátis</span>
      </Flex>
      <p className="text-secondary">
        Fornecedores que participam da política de &quot;Envio Grátis&quot; não
        podem alterar o custo de envio
      </p>
    </div>
  );
};
